var exports = {
  "g": "MessageCrosspostConfirmModal.module__reach___S1BJck",
  "x": "MessageCrosspostConfirmModal.module__reachIcon___S1BJck",
};

module.exports = exports;
